import request from "@/utils/request";
import qs from "qs";

/**
 * 查询考核任务列表
 * @param {Object} params
 * @param {number|string} [params.userId] 用户ID
 * @param {number|string} [params.agentId] 代理商用户ID
 * @param {number|string} [params.teamLogo] 团队标识
 * @param {number|string} [params.statue] 状态(0:进行中 1:未完成 2:已完成)
 * @param {number} params.page 页码
 * @param {number} params.pageSize 每页条数
 */
export function getAgentPartnerTaskList(params) {
  return request({
    url: "/agentPartnerTask/getAgentPartnerTaskList",
    method: "get",
    params,
  });
}

/**
 * 审核考核任务
 * @param {Object} data
 * @param {number|string} data.taskId 考核任务ID
 * @param {number} data.status 审核状态 (0:进行中 1:未完成 2:已完成)
 */
export function reviewAgentTask(data) {
  return request.post("/agentPartnerTask/reviewAgentTask", qs.stringify(data));
}

/**
 * 新增考核任务
 * @param {Object} data
 * @param {number|string} data.userId 合伙人ID
 * @param {number|string} data.agentUserId 代理商用户ID
 * @param {string} data.startTime 任务开始时间
 * @param {string} data.endTime 任务结束时间
 * @param {number|string} data.goodsId 商品ID
 * @param {number} data.type 团队类型(0:地图团队 1:推荐团队)
 */
export function addAgentTask(params) {
  return request.post("/agentPartnerTask/addAgentTask", qs.stringify(params));
}
